// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1kHT_","Search":"Button_Search__1cCMR"};